/**
 * Generated from MaryShelleyCutouts.fla
 */
export function MaryShelleyCutouts(this: IMaryShelleyCutouts) {
	const cutouts = this.cutouts;
	if (!cutouts[0] && cutouts.elementFactory) {
		cutouts[0] = cutouts.elementFactory(0,undefined);
	}
	if (cutouts[0]) {
		MaryShelleyCutouts_sheAnt1.call(cutouts[0] as IMaryShelleyCutouts_sheAnt1);
		cutouts[0].x = 712;
		cutouts[0].y = 532.5;
		if (cutouts[0].onLayout) cutouts[0].onLayout();
	}
	if (!cutouts[1] && cutouts.elementFactory) {
		cutouts[1] = cutouts.elementFactory(1,undefined);
	}
	if (cutouts[1]) {
		MaryShelleyCutouts_sheBestfriends11.call(cutouts[1] as IMaryShelleyCutouts_sheBestfriends11);
		cutouts[1].x = 914.5;
		cutouts[1].y = 653.5;
		if (cutouts[1].onLayout) cutouts[1].onLayout();
	}
	if (!cutouts[2] && cutouts.elementFactory) {
		cutouts[2] = cutouts.elementFactory(2,undefined);
	}
	if (cutouts[2]) {
		MaryShelleyCutouts_sheBestfriends21.call(cutouts[2] as IMaryShelleyCutouts_sheBestfriends21);
		cutouts[2].x = 953.5;
		cutouts[2].y = 693;
		if (cutouts[2].onLayout) cutouts[2].onLayout();
	}
	if (!cutouts[3] && cutouts.elementFactory) {
		cutouts[3] = cutouts.elementFactory(3,undefined);
	}
	if (cutouts[3]) {
		MaryShelleyCutouts_sheBestfriends31.call(cutouts[3] as IMaryShelleyCutouts_sheBestfriends31);
		cutouts[3].x = 986;
		cutouts[3].y = 729;
		if (cutouts[3].onLayout) cutouts[3].onLayout();
	}
	if (!cutouts[4] && cutouts.elementFactory) {
		cutouts[4] = cutouts.elementFactory(4,undefined);
	}
	if (cutouts[4]) {
		MaryShelleyCutouts_sheBg1.call(cutouts[4] as IMaryShelleyCutouts_sheBg1);
		cutouts[4].x = 7.2;
		cutouts[4].y = 321.95;
		if (cutouts[4].onLayout) cutouts[4].onLayout();
	}
	if (!cutouts[5] && cutouts.elementFactory) {
		cutouts[5] = cutouts.elementFactory(5,undefined);
	}
	if (cutouts[5]) {
		MaryShelleyCutouts_sheBoogie1.call(cutouts[5] as IMaryShelleyCutouts_sheBoogie1);
		cutouts[5].x = 785;
		cutouts[5].y = 502;
		if (cutouts[5].onLayout) cutouts[5].onLayout();
	}
	if (!cutouts[6] && cutouts.elementFactory) {
		cutouts[6] = cutouts.elementFactory(6,undefined);
	}
	if (cutouts[6]) {
		MaryShelleyCutouts_sheBookmonster1.call(cutouts[6] as IMaryShelleyCutouts_sheBookmonster1);
		cutouts[6].x = 526;
		cutouts[6].y = 315;
		if (cutouts[6].onLayout) cutouts[6].onLayout();
	}
	if (!cutouts[7] && cutouts.elementFactory) {
		cutouts[7] = cutouts.elementFactory(7,undefined);
	}
	if (cutouts[7]) {
		MaryShelleyCutouts_sheBookmonsterArmdown1.call(cutouts[7] as IMaryShelleyCutouts_sheBookmonsterArmdown1);
		cutouts[7].x = 800.5;
		cutouts[7].y = 580.5;
		if (cutouts[7].onLayout) cutouts[7].onLayout();
	}
	if (!cutouts[8] && cutouts.elementFactory) {
		cutouts[8] = cutouts.elementFactory(8,undefined);
	}
	if (cutouts[8]) {
		MaryShelleyCutouts_sheBookmonsterArmup1.call(cutouts[8] as IMaryShelleyCutouts_sheBookmonsterArmup1);
		cutouts[8].x = 800.5;
		cutouts[8].y = 580.5;
		if (cutouts[8].onLayout) cutouts[8].onLayout();
	}
	if (!cutouts[9] && cutouts.elementFactory) {
		cutouts[9] = cutouts.elementFactory(9,undefined);
	}
	if (cutouts[9]) {
		MaryShelleyCutouts_sheBowtie1.call(cutouts[9] as IMaryShelleyCutouts_sheBowtie1);
		cutouts[9].x = 926.5;
		cutouts[9].y = 716;
		if (cutouts[9].onLayout) cutouts[9].onLayout();
	}
	if (!cutouts[10] && cutouts.elementFactory) {
		cutouts[10] = cutouts.elementFactory(10,undefined);
	}
	if (cutouts[10]) {
		MaryShelleyCutouts_sheBroccoli1.call(cutouts[10] as IMaryShelleyCutouts_sheBroccoli1);
		cutouts[10].x = 882.5;
		cutouts[10].y = 632;
		if (cutouts[10].onLayout) cutouts[10].onLayout();
	}
	if (!cutouts[11] && cutouts.elementFactory) {
		cutouts[11] = cutouts.elementFactory(11,undefined);
	}
	if (cutouts[11]) {
		MaryShelleyCutouts_sheCrayons1.call(cutouts[11] as IMaryShelleyCutouts_sheCrayons1);
		cutouts[11].x = 942.5;
		cutouts[11].y = 686.5;
		if (cutouts[11].onLayout) cutouts[11].onLayout();
	}
	if (!cutouts[12] && cutouts.elementFactory) {
		cutouts[12] = cutouts.elementFactory(12,undefined);
	}
	if (cutouts[12]) {
		MaryShelleyCutouts_sheFeather1.call(cutouts[12] as IMaryShelleyCutouts_sheFeather1);
		cutouts[12].x = 922.5;
		cutouts[12].y = 603;
		if (cutouts[12].onLayout) cutouts[12].onLayout();
	}
	if (!cutouts[13] && cutouts.elementFactory) {
		cutouts[13] = cutouts.elementFactory(13,undefined);
	}
	if (cutouts[13]) {
		MaryShelleyCutouts_sheFlashlight1.call(cutouts[13] as IMaryShelleyCutouts_sheFlashlight1);
		cutouts[13].x = 848;
		cutouts[13].y = 594;
		if (cutouts[13].onLayout) cutouts[13].onLayout();
	}
	if (!cutouts[14] && cutouts.elementFactory) {
		cutouts[14] = cutouts.elementFactory(14,undefined);
	}
	if (cutouts[14]) {
		MaryShelleyCutouts_sheLantern1.call(cutouts[14] as IMaryShelleyCutouts_sheLantern1);
		cutouts[14].x = 914.5;
		cutouts[14].y = 590.5;
		if (cutouts[14].onLayout) cutouts[14].onLayout();
	}
	if (!cutouts[15] && cutouts.elementFactory) {
		cutouts[15] = cutouts.elementFactory(15,undefined);
	}
	if (cutouts[15]) {
		MaryShelleyCutouts_sheMoustache1.call(cutouts[15] as IMaryShelleyCutouts_sheMoustache1);
		cutouts[15].x = 883.5;
		cutouts[15].y = 734;
		if (cutouts[15].onLayout) cutouts[15].onLayout();
	}
	if (!cutouts[16] && cutouts.elementFactory) {
		cutouts[16] = cutouts.elementFactory(16,undefined);
	}
	if (cutouts[16]) {
		MaryShelleyCutouts_shePie1.call(cutouts[16] as IMaryShelleyCutouts_shePie1);
		cutouts[16].x = 714.5;
		cutouts[16].y = 638;
		if (cutouts[16].onLayout) cutouts[16].onLayout();
	}
	if (!cutouts[17] && cutouts.elementFactory) {
		cutouts[17] = cutouts.elementFactory(17,undefined);
	}
	if (cutouts[17]) {
		MaryShelleyCutouts_sheSandwich1.call(cutouts[17] as IMaryShelleyCutouts_sheSandwich1);
		cutouts[17].x = 922;
		cutouts[17].y = 666.5;
		if (cutouts[17].onLayout) cutouts[17].onLayout();
	}
	if (!cutouts[18] && cutouts.elementFactory) {
		cutouts[18] = cutouts.elementFactory(18,undefined);
	}
	if (cutouts[18]) {
		MaryShelleyCutouts_sheSillyglasses1.call(cutouts[18] as IMaryShelleyCutouts_sheSillyglasses1);
		cutouts[18].x = 865.5;
		cutouts[18].y = 695;
		if (cutouts[18].onLayout) cutouts[18].onLayout();
	}
	if (!cutouts[19] && cutouts.elementFactory) {
		cutouts[19] = cutouts.elementFactory(19,undefined);
	}
	if (cutouts[19]) {
		MaryShelleyCutouts_sheSuperhero1.call(cutouts[19] as IMaryShelleyCutouts_sheSuperhero1);
		cutouts[19].x = 828.5;
		cutouts[19].y = 419.5;
		if (cutouts[19].onLayout) cutouts[19].onLayout();
	}
	if (!cutouts[20] && cutouts.elementFactory) {
		cutouts[20] = cutouts.elementFactory(20,undefined);
	}
	if (cutouts[20]) {
		MaryShelleyCutouts_sheSuperheroArmout1.call(cutouts[20] as IMaryShelleyCutouts_sheSuperheroArmout1);
		cutouts[20].x = 805.5;
		cutouts[20].y = 419.5;
		if (cutouts[20].onLayout) cutouts[20].onLayout();
	}
	if (!cutouts[21] && cutouts.elementFactory) {
		cutouts[21] = cutouts.elementFactory(21,undefined);
	}
	if (cutouts[21]) {
		MaryShelleyCutouts_sheTeddybear1.call(cutouts[21] as IMaryShelleyCutouts_sheTeddybear1);
		cutouts[21].x = 904;
		cutouts[21].y = 622;
		if (cutouts[21].onLayout) cutouts[21].onLayout();
	}
	if (!cutouts[22] && cutouts.elementFactory) {
		cutouts[22] = cutouts.elementFactory(22,undefined);
	}
	if (cutouts[22]) {
		MaryShelleyCutouts_sheTophat1.call(cutouts[22] as IMaryShelleyCutouts_sheTophat1);
		cutouts[22].x = 799;
		cutouts[22].y = 561;
		if (cutouts[22].onLayout) cutouts[22].onLayout();
	}
	if (!cutouts[23] && cutouts.elementFactory) {
		cutouts[23] = cutouts.elementFactory(23,undefined);
	}
	if (cutouts[23]) {
		MaryShelleyCutouts_sheToy1.call(cutouts[23] as IMaryShelleyCutouts_sheToy1);
		cutouts[23].x = 902;
		cutouts[23].y = 679.5;
		if (cutouts[23].onLayout) cutouts[23].onLayout();
	}
	if (!cutouts[24] && cutouts.elementFactory) {
		cutouts[24] = cutouts.elementFactory(24,undefined);
	}
	if (cutouts[24]) {
		MaryShelleyCutouts_sheWand1.call(cutouts[24] as IMaryShelleyCutouts_sheWand1);
		cutouts[24].x = 861.5;
		cutouts[24].y = 607;
		if (cutouts[24].onLayout) cutouts[24].onLayout();
	}
	if (!cutouts[25] && cutouts.elementFactory) {
		cutouts[25] = cutouts.elementFactory(25,undefined);
	}
	if (cutouts[25]) {
		MaryShelleyCutouts_sheXBrave1.call(cutouts[25] as IMaryShelleyCutouts_sheXBrave1);
		cutouts[25].x = 829.5;
		cutouts[25].y = 438;
		if (cutouts[25].onLayout) cutouts[25].onLayout();
	}
	if (!cutouts[26] && cutouts.elementFactory) {
		cutouts[26] = cutouts.elementFactory(26,undefined);
	}
	if (cutouts[26]) {
		MaryShelleyCutouts_sheXDefend1.call(cutouts[26] as IMaryShelleyCutouts_sheXDefend1);
		cutouts[26].x = 807.5;
		cutouts[26].y = 427.5;
		if (cutouts[26].onLayout) cutouts[26].onLayout();
	}
	if (!cutouts[27] && cutouts.elementFactory) {
		cutouts[27] = cutouts.elementFactory(27,undefined);
	}
	if (cutouts[27]) {
		MaryShelleyCutouts_sheXFunny1.call(cutouts[27] as IMaryShelleyCutouts_sheXFunny1);
		cutouts[27].x = 845.5;
		cutouts[27].y = 442.5;
		if (cutouts[27].onLayout) cutouts[27].onLayout();
	}
	if (!cutouts[28] && cutouts.elementFactory) {
		cutouts[28] = cutouts.elementFactory(28,undefined);
	}
	if (cutouts[28]) {
		MaryShelleyCutouts_sheXFunny_21.call(cutouts[28] as IMaryShelleyCutouts_sheXFunny_21);
		cutouts[28].x = 842;
		cutouts[28].y = 426.5;
		if (cutouts[28].onLayout) cutouts[28].onLayout();
	}
	if (!cutouts[29] && cutouts.elementFactory) {
		cutouts[29] = cutouts.elementFactory(29,undefined);
	}
	if (cutouts[29]) {
		MaryShelleyCutouts_sheXHide1.call(cutouts[29] as IMaryShelleyCutouts_sheXHide1);
		cutouts[29].x = 728;
		cutouts[29].y = 536.5;
		if (cutouts[29].onLayout) cutouts[29].onLayout();
	}
	if (!cutouts[30] && cutouts.elementFactory) {
		cutouts[30] = cutouts.elementFactory(30,undefined);
	}
	if (cutouts[30]) {
		MaryShelleyCutouts_sheXInvisible1.call(cutouts[30] as IMaryShelleyCutouts_sheXInvisible1);
		cutouts[30].x = 841.5;
		cutouts[30].y = 435.5;
		if (cutouts[30].onLayout) cutouts[30].onLayout();
	}
	if (!cutouts[31] && cutouts.elementFactory) {
		cutouts[31] = cutouts.elementFactory(31,undefined);
	}
	if (cutouts[31]) {
		MaryShelleyCutouts_sheXKind1.call(cutouts[31] as IMaryShelleyCutouts_sheXKind1);
		cutouts[31].x = 780;
		cutouts[31].y = 406;
		if (cutouts[31].onLayout) cutouts[31].onLayout();
	}
	if (!cutouts[32] && cutouts.elementFactory) {
		cutouts[32] = cutouts.elementFactory(32,undefined);
	}
	if (cutouts[32]) {
		MaryShelleyCutouts_sheXRun1.call(cutouts[32] as IMaryShelleyCutouts_sheXRun1);
		cutouts[32].x = 794;
		cutouts[32].y = 454.5;
		if (cutouts[32].onLayout) cutouts[32].onLayout();
	}
	if (!cutouts[33] && cutouts.elementFactory) {
		cutouts[33] = cutouts.elementFactory(33,undefined);
	}
	if (cutouts[33]) {
		MaryShelleyCutouts_sheXShare1.call(cutouts[33] as IMaryShelleyCutouts_sheXShare1);
		cutouts[33].x = 808.5;
		cutouts[33].y = 429;
		if (cutouts[33].onLayout) cutouts[33].onLayout();
	}
	if (!cutouts[34] && cutouts.elementFactory) {
		cutouts[34] = cutouts.elementFactory(34,undefined);
	}
	if (cutouts[34]) {
		MaryShelleyCutouts_sheXSpooky1.call(cutouts[34] as IMaryShelleyCutouts_sheXSpooky1);
		cutouts[34].x = 845;
		cutouts[34].y = 450.5;
		if (cutouts[34].onLayout) cutouts[34].onLayout();
	}
	if (!cutouts[35] && cutouts.elementFactory) {
		cutouts[35] = cutouts.elementFactory(35,undefined);
	}
	if (cutouts[35]) {
		MaryShelleyCutouts_sheXStatue1.call(cutouts[35] as IMaryShelleyCutouts_sheXStatue1);
		cutouts[35].x = 820;
		cutouts[35].y = 407.5;
		if (cutouts[35].onLayout) cutouts[35].onLayout();
	}
	if (!cutouts[36] && cutouts.elementFactory) {
		cutouts[36] = cutouts.elementFactory(36,undefined);
	}
	if (cutouts[36]) {
		MaryShelleyCutouts_sheXSurprised1.call(cutouts[36] as IMaryShelleyCutouts_sheXSurprised1);
		cutouts[36].x = 847;
		cutouts[36].y = 442.5;
		if (cutouts[36].onLayout) cutouts[36].onLayout();
	}
	if (!cutouts[37] && cutouts.elementFactory) {
		cutouts[37] = cutouts.elementFactory(37,undefined);
	}
	if (cutouts[37]) {
		MaryShelleyCutouts_sheGhost1.call(cutouts[37] as IMaryShelleyCutouts_sheGhost1);
		cutouts[37].x = 710.5;
		cutouts[37].y = 347.5;
		if (cutouts[37].onLayout) cutouts[37].onLayout();
	}
	return this;
}
function MaryShelleyCutouts_sheAnt1(this: IMaryShelleyCutouts_sheAnt1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [23.95,-2.40,89.00,-17.15,151.00,12.90,181.65,-1.20,218.50,6.80,244.25,-11.00,287.20,-3.65,306.85,28.85,334.45,35.00,353.50,60.15,354.70,81.65,379.25,129.50,379.25,156.50,398.85,173.20,429.20,132.25,479.20,107.85,539.05,103.50,587.05,122.05,627.25,163.00,635.90,215.75,620.55,219.30,589.45,253.55,544.95,275.60,491.40,272.85,448.85,255.95,484.30,350.80,483.90,379.95,534.30,383.10,534.30,414.20,514.60,426.40,552.40,429.55,556.75,456.70,532.35,474.45,496.90,469.30,465.00,440.95,442.15,387.45,413.80,324.45,398.45,275.60,355.90,285.45,355.15,369.35,346.85,389.00,339.80,437.85,322.90,467.35,294.15,482.35,266.20,481.55,253.20,473.65,253.20,446.90,284.30,439.40,304.00,429.95,306.75,396.90,287.05,417.00,259.50,420.15,238.20,413.85,222.10,446.90,196.05,470.90,157.45,475.65,135.05,464.60,136.60,433.90,149.60,426.80,125.60,415.00,124.40,381.50,173.60,383.10,184.25,340.55,222.45,251.15,188.60,251.60,161.80,275.60,123.25,276.40,93.35,253.95,80.75,220.10,90.60,179.15,70.90,153.15,76.80,127.15,87.40,113.40,88.60,92.90,101.60,73.20,49.60,68.55,12.60,76.80,-5.50,71.30,-7.50,43.35,8.65,33.85,24.60,23.95];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheAnt.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 624.00;
	sprite.height = 471.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol1(this: IMaryShelleyCutouts_Symbol1) {
	return this;
}
function MaryShelleyCutouts_sheAnt(this: IMaryShelleyCutouts_sheAnt) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-ant.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheBestfriends11(this: IMaryShelleyCutouts_sheBestfriends11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [132.90,15.85,166.00,-11.35,202.10,-9.85,226.80,25.70,234.20,84.00,222.35,139.25,214.45,180.75,187.75,242.05,130.95,229.20,73.65,208.45,36.10,178.35,4.95,139.85,-11.80,93.40,-4.40,53.40,25.25,40.05,71.65,41.50,115.65,60.80];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheBestfriends1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 219.00;
	sprite.height = 229.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol2(this: IMaryShelleyCutouts_Symbol2) {
	return this;
}
function MaryShelleyCutouts_sheBestfriends1(this: IMaryShelleyCutouts_sheBestfriends1) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bestfriends1.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheBestfriends21(this: IMaryShelleyCutouts_sheBestfriends21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [77.55,1.55,104.25,-12.30,131.90,-4.90,148.70,22.75,154.65,62.30,143.75,107.25,117.10,159.10,88.95,158.60,57.80,142.80,16.30,113.15,-11.35,73.65,-9.85,40.05,13.35,28.70,58.30,35.10];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheBestfriends2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 141.00;
	sprite.height = 150.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol3(this: IMaryShelleyCutouts_Symbol3) {
	return this;
}
function MaryShelleyCutouts_sheBestfriends2(this: IMaryShelleyCutouts_sheBestfriends2) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bestfriends2.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheBestfriends31(this: IMaryShelleyCutouts_sheBestfriends31) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [23.75,-7.90,39.90,2.85,71.20,-0.30,85.75,13.90,84.80,43.95,63.30,69.90,35.15,86.00,11.75,83.15,-5.00,50.30,-12.30,18.35,-6.25,5.90,-0.25,-6.30];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheBestfriends3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 76.00;
	sprite.height = 78.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol4(this: IMaryShelleyCutouts_Symbol4) {
	return this;
}
function MaryShelleyCutouts_sheBestfriends3(this: IMaryShelleyCutouts_sheBestfriends3) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bestfriends3.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheBg1(this: IMaryShelleyCutouts_sheBg1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [249.12,543.51,227.41,542.05,211.76,543.03,196.75,546.86,179.81,576.79,154.36,591.84,146.23,630.32,128.08,631.18,126.41,641.59,111.66,657.50,88.44,669.88,69.65,693.96,61.39,720.66,53.14,738.03,53.14,756.78,78.46,778.84,84.53,787.40,98.59,790.66,113.72,806.96,119.23,824.29,144.29,845.79,136.81,850.99,137.93,869.48,203.50,877.74,230.63,877.22,230.63,877.09,396.22,873.91,455.17,853.48,492.37,853.79,575.01,844.67,629.32,843.04,652.19,851.29,704.52,857.35,773.92,852.19,773.92,852.32,780.11,851.94,828.92,844.80,833.60,825.23,895.26,824.98,969.65,820.29,975.15,797.67,964.62,766.07,947.76,763.88,924.24,766.97,924.50,742.85,904.64,730.08,897.97,697.10,872.13,698.13,856.74,711.72,850.03,692.41,818.85,689.83,807.76,679.43,773.92,696.97,773.92,698.04,597.93,705.10,583.14,701.44,571.53,696.80,554.84,682.22,533.09,678.65,475.51,606.07,426.45,599.75,419.83,591.02,401.98,592.18,395.32,605.77,373.17,613.90,360.83,605.43,353.40,596.95,349.44,582.34,334.26,579.41,298.01,554.43,265.55,545.57];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [1165.54,658.97,1151.14,667.32,1145.03,676.47,1128.22,692.21,1111.45,709.02,1105.08,741.70,1082.29,760.66,1080.45,783.28,1067.76,800.22,1066.77,825.03,1101.56,858.31,1153.20,857.50,1169.45,863.30,1189.62,865.54,1247.84,882.09,1262.20,881.23,1281.55,889.79,1329.58,895.85,1381.18,903.03,1451.26,901.40,1473.37,904.15,1500.11,900.28,1539.58,901.40,1589.81,889.79,1625.97,891.47,1665.74,901.96,1700.48,905.27,1726.71,905.01,1807.38,893.96,1834.17,894.26,1857.90,901.14,1911.43,907.76,1964.71,905.83,2005.00,898.95,2036.99,898.95,2037.29,874.09,2008.87,843.18,1973.27,816.43,1945.36,801.81,1936.80,752.67,1934.61,717.88,1929.62,685.29,1926.79,676.09,1927.95,649.90,1922.70,606.60,1908.90,572.12,1893.12,529.89,1887.87,509.73,1889.29,455.63,1887.23,425.41,1781.67,440.37,1781.67,444.28,1654.86,462.26,1625.62,467.29,1618.66,486.94,1600.73,491.80,1591.35,526.02,1563.92,531.18,1548.53,577.32,1542.03,602.22,1531.07,580.29,1504.63,557.24,1492.50,535.40,1454.53,529.03,1429.34,527.05,1368.19,564.16,1357.23,568.16,1352.63,585.45,1331.90,606.73,1309.46,593.49,1306.02,582.01,1288.17,580.29,1274.93,586.61,1198.69,618.21,1187.34,656.26];
	}
	if (!polygons[2] && polygons.elementFactory) {
		polygons[2] = polygons.elementFactory(2,undefined);
	}
	if (polygons[2]) {
		polygons[2] = [1891.19,-14.04,1892.35,-14.00,1734.71,-14.94,1735.45,-14.90,678.80,-15.37,678.80,-15.33,33.56,-15.63,13.70,17.56,21.44,46.50,0.76,76.26,-6.68,129.40,-14.68,141.27,-13.86,184.79,15.63,220.60,23.37,276.54,63.32,321.43,67.45,350.11,87.31,357.55,94.45,370.50,185.31,395.82,199.37,385.37,240.39,379.87,240.43,379.91,245.85,393.33,261.63,432.20,264.68,453.14,265.50,493.90,266.10,550.10,273.75,553.24,340.01,588.58,337.05,546.62,337.99,507.79,344.36,461.18,348.27,424.07,358.68,399.00,376.00,375.74,381.94,353.04,412.04,346.80,426.18,356.82,427.56,389.50,433.41,441.01,437.11,513.77,435.99,553.33,428.20,565.02,428.20,581.70,438.22,601.23,436.07,607.29,469.87,606.04,526.37,682.54,526.80,682.58,530.11,687.52,514.16,618.17,511.23,578.95,519.02,503.88,535.66,532.82,559.39,595.81,582.66,642.81,599.08,710.40,599.64,714.79,684.99,706.14,684.99,705.76,821.12,697.20,823.02,686.84,820.01,657.90,817.34,622.34,809.99,585.79,804.74,541.07,793.43,497.99,793.56,473.31,814.12,440.07,831.83,378.58,859.74,321.82,873.28,288.20,904.28,251.99,941.09,220.04,952.83,218.88,964.09,228.47,1005.67,225.63,1018.66,195.84,1052.20,195.02,1062.26,181.43,1063.16,156.62,1073.57,151.81,1085.91,155.98,1092.92,219.36,1107.45,226.06,1109.30,244.64,1146.62,274.27,1159.27,317.35,1162.23,350.97,1171.00,427.13,1191.34,479.41,1200.93,523.53,1203.30,568.03,1201.75,596.75,1197.75,621.26,1230.34,609.44,1230.34,607.42,1291.10,594.09,1283.66,567.90,1280.99,550.19,1274.24,536.38,1276.39,453.91,1284.48,355.83,1289.25,333.52,1310.15,317.91,1320.42,337.86,1328.16,375.01,1350.14,407.26,1359.08,459.07,1366.00,502.37,1365.44,574.52,1430.11,542.75,1430.67,463.67,1438.11,423.73,1467.26,347.58,1485.84,323.84,1514.48,298.17,1525.48,306.47,1540.02,310.60,1545.43,339.92,1557.78,352.74,1578.20,351.75,1590.93,348.82,1602.32,371.01,1610.23,423.17,1632.38,444.84,1642.65,455.50,1654.13,470.55,1732.48,454.04,1732.48,455.25,1887.06,433.36,1883.88,387.14,1875.62,349.30,1871.75,322.25,1875.58,285.27,1881.64,251.61,1885.81,215.44,1921.89,215.92,1930.74,208.74,1969.92,205.68,1978.21,173.39,2017.69,162.94,2023.49,147.20,2019.36,121.23,2041.94,93.11,2039.19,53.94,2046.37,39.58,2046.11,18.60,2036.69,3.46,2027.15,-12.15];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheBg.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 2035.73;
	sprite.height = 898.44;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol5(this: IMaryShelleyCutouts_Symbol5) {
	return this;
}
function MaryShelleyCutouts_Symbol6(this: IMaryShelleyCutouts_Symbol6) {
	return this;
}
function MaryShelleyCutouts_Symbol7(this: IMaryShelleyCutouts_Symbol7) {
	return this;
}
function MaryShelleyCutouts_sheBg(this: IMaryShelleyCutouts_sheBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bg.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheBoogie1(this: IMaryShelleyCutouts_sheBoogie1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [252.10,54.65,304.00,62.25,307.25,49.80,326.75,50.35,328.35,33.55,359.20,34.65,365.15,67.65,391.65,84.40,394.90,110.35,424.05,137.95,444.05,171.45,466.80,170.40,476.00,201.75,491.10,205.55,489.50,236.35,473.25,242.30,477.05,292.60,474.90,337.50,460.30,389.45,474.90,393.20,472.20,421.90,446.25,426.20,432.70,446.75,430.55,472.70,405.10,475.45,359.70,510.05,300.75,536.05,231.50,545.75,165.55,538.70,126.60,524.65,97.40,510.05,67.65,516.00,62.75,491.65,47.10,486.80,41.15,460.80,20.60,437.55,5.45,438.10,6.00,398.60,-8.05,354.25,-12.40,305.60,-4.30,243.95,20.60,186.60,9.20,186.60,6.00,155.20,28.70,149.25,32.50,112.55,63.30,109.85,63.85,129.30,113.05,88.75,111.45,61.15,141.20,56.30,149.30,72.50,155.80,47.65,182.85,46.00,185.55,61.15,216.95,55.20,217.15,22.25,217.00,-10.25,248.30,-10.25];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheBoogie.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 478.00;
	sprite.height = 532.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol8(this: IMaryShelleyCutouts_Symbol8) {
	return this;
}
function MaryShelleyCutouts_sheBoogie(this: IMaryShelleyCutouts_sheBoogie) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-boogie.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheBookmonster1(this: IMaryShelleyCutouts_sheBookmonster1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [186.15,45.90,249.15,9.40,299.95,-8.00,333.35,2.80,370.95,-8.70,395.65,-6.95,403.65,2.80,489.60,12.20,496.55,25.75,541.10,27.15,549.80,41.05,614.20,55.00,612.45,90.10,628.80,138.10,631.95,202.50,654.95,212.25,659.80,234.20,678.95,241.85,690.80,211.20,705.75,204.95,718.60,151.70,756.55,150.65,766.60,123.50,788.90,106.45,843.15,88.70,875.90,95.70,902.70,97.75,912.05,113.10,954.85,150.35,1004.30,213.30,1004.30,238.70,969.15,283.60,928.10,307.95,912.10,359.85,892.95,380.00,865.45,385.60,852.95,410.60,827.55,417.20,817.45,439.85,757.95,468.40,740.55,469.80,726.95,496.95,700.20,502.15,712.35,512.60,710.60,547.75,704.65,590.55,694.90,600.65,709.90,634.40,708.85,659.80,692.85,673.40,662.90,670.95,665.00,710.60,679.30,718.25,689.35,746.45,699.45,770.80,698.40,788.55,716.50,795.15,724.15,817.75,753.75,826.10,757.95,869.65,764.20,881.80,765.60,915.60,657.00,920.10,515.75,919.40,370.25,920.45,245.70,919.40,121.15,920.45,7.70,919.75,-6.55,913.15,-6.20,888.75,38.30,860.60,46.65,832.05,76.60,820.90,93.65,790.25,85.30,773.90,90.50,750.25,113.50,740.85,116.95,721.70,129.15,710.25,116.95,666.40,119.40,639.60,107.55,612.10,111.00,581.85,122.15,571.75,126.00,531.05,99.55,498.65,82.15,485.80,76.25,453.10,59.85,444.00,55.00,424.20,61.25,401.90,89.10,395.30,92.55,358.80,132.90,350.40,162.15,274.55,161.45,237.30,153.45,210.50,140.20,203.20,136.05,165.95,130.45,137.80,137.75,112.00,153.40,109.25,160.75,83.50,188.60,74.80];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheBookmonster.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 996.00;
	sprite.height = 906.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol9(this: IMaryShelleyCutouts_Symbol9) {
	return this;
}
function MaryShelleyCutouts_sheBookmonster(this: IMaryShelleyCutouts_sheBookmonster) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bookmonster.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheBookmonsterArmdown1(this: IMaryShelleyCutouts_sheBookmonsterArmdown1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [364.40,0.90,255.20,-14.30,243.55,6.30,228.30,-0.85,205.05,1.80,184.45,22.40,162.95,40.30,156.70,79.70,102.10,99.40,73.45,121.80,72.55,147.75,51.95,159.40,39.40,181.75,-8.95,222.05,-7.15,250.70,14.35,259.65,22.40,278.45,69.85,274.00,45.70,303.55,44.80,329.50,75.20,357.25,176.40,388.60,211.30,347.40,216.70,377.85,255.20,391.25,333.95,345.60,339.35,321.45,323.20,266.80,327.70,228.30,346.50,209.50,381.40,223.85,430.65,231.90,458.40,205.90,456.90,127.40,448.50,31.35];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheBookmonsterArmdown.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 447.00;
	sprite.height = 375.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol10(this: IMaryShelleyCutouts_Symbol10) {
	return this;
}
function MaryShelleyCutouts_sheBookmonsterArmdown(this: IMaryShelleyCutouts_sheBookmonsterArmdown) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bookmonster-armdown.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheBookmonsterArmup1(this: IMaryShelleyCutouts_sheBookmonsterArmup1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [77.10,18.85,68.15,33.15,42.15,47.50,43.05,68.10,66.35,103.95,24.25,88.70,13.50,116.50,-8.05,121.85,-10.70,152.35,45.75,201.60,53.80,221.35,71.70,228.50,77.10,257.15,112.95,283.15,155.05,294.80,158.65,331.55,210.60,375.45,245.55,369.20,259.00,386.20,299.30,387.10,368.30,374.55,449.85,343.20,461.50,167.55,432.80,146.05,391.60,145.15,341.45,165.80,328.00,116.50,339.65,42.10,301.10,8.95,252.70,-15.20,218.65,-0.90,209.70,29.60,193.70,7.65,175.65,-14.35];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheBookmonsterArmup.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 447.00;
	sprite.height = 375.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol11(this: IMaryShelleyCutouts_Symbol11) {
	return this;
}
function MaryShelleyCutouts_sheBookmonsterArmup(this: IMaryShelleyCutouts_sheBookmonsterArmup) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bookmonster-armup.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheBowtie1(this: IMaryShelleyCutouts_sheBowtie1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [17.05,-14.35,47.50,-8.95,78.85,8.95,123.65,9.85,156.85,-8.05,202.55,-8.05,211.50,25.10,202.55,45.70,208.80,70.80,204.30,99.45,171.15,107.55,129.95,95.00,86.05,96.80,47.50,117.40,6.30,115.60,-12.15,90.85,-9.95,47.50,-13.50,4.10];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheBowtie.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 195.00;
	sprite.height = 104.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol12(this: IMaryShelleyCutouts_Symbol12) {
	return this;
}
function MaryShelleyCutouts_sheBowtie(this: IMaryShelleyCutouts_sheBowtie) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-bowtie.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheBroccoli1(this: IMaryShelleyCutouts_sheBroccoli1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [162.50,18.95,252.10,52.25,274.45,76.40,284.80,147.00,295.15,171.15,289.95,211.30,272.15,225.65,257.80,254.40,237.15,261.25,219.35,280.75,191.25,284.20,166.55,274.45,156.80,244.00,123.50,243.45,85.60,253.20,55.75,274.45,19.55,271.60,-3.40,257.25,-11.45,226.80,-4.55,203.85,24.75,187.75,35.05,153.90,0.05,127.50,-9.15,102.80,2.35,62.60,50.55,37.35,72.40,1.75,104.55,-12.05,120.75,-9.20,136.65,-6.85];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheBroccoli.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 283.00;
	sprite.height = 272.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol13(this: IMaryShelleyCutouts_Symbol13) {
	return this;
}
function MaryShelleyCutouts_sheBroccoli(this: IMaryShelleyCutouts_sheBroccoli) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-broccoli.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheCrayons1(this: IMaryShelleyCutouts_sheCrayons1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [3.50,101.15,33.95,35.05,69.55,-9.75,101.15,-9.75,106.90,22.45,144.25,17.25,150.60,43.70,173.00,48.30,174.70,76.45,127.60,122.40,44.85,171.80,19.60,173.55,-3.40,156.30,-11.45,141.95,-11.35,130.45,-10.85,118.95];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheCrayons.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 163.00;
	sprite.height = 163.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol14(this: IMaryShelleyCutouts_Symbol14) {
	return this;
}
function MaryShelleyCutouts_sheCrayons(this: IMaryShelleyCutouts_sheCrayons) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-crayons.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheFeather1(this: IMaryShelleyCutouts_sheFeather1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [183.55,-8.05,210.55,-7.45,216.30,34.55,207.10,58.10,191.60,73.65,202.50,86.30,203.10,102.40,195.00,111.00,186.95,144.95,157.60,176.00,148.40,178.85,143.25,188.05,89.15,229.50,85.70,259.40,64.45,282.40,51.80,302.50,40.90,337.00,19.00,336.50,4.05,298.50,-8.05,251.90,-12.65,211.05,3.45,170.80,24.80,150.15,49.50,100.65,73.65,54.10,96.65,32.25,115.65,26.50,124.30,5.20,153.05,3.45,160.50,27.05];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheFeather.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 203.00;
	sprite.height = 330.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol15(this: IMaryShelleyCutouts_Symbol15) {
	return this;
}
function MaryShelleyCutouts_sheFeather(this: IMaryShelleyCutouts_sheFeather) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-feather.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheFlashlight1(this: IMaryShelleyCutouts_sheFlashlight1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [54.05,232.85,76.55,190.10,103.55,185.60,96.80,144.00,131.65,92.25,173.30,102.35,252.90,-9.65,324.00,25.65,363.15,96.05,247.50,176.60,257.65,217.10,219.35,251.95,172.15,250.85,47.30,358.85,12.40,358.85,-10.10,337.45,-11.65,326.20,-12.95,314.75,-3.35,293.60];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheFlashlight.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 352.00;
	sprite.height = 348.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol16(this: IMaryShelleyCutouts_Symbol16) {
	return this;
}
function MaryShelleyCutouts_sheFlashlight(this: IMaryShelleyCutouts_sheFlashlight) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-flashlight.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheLantern1(this: IMaryShelleyCutouts_sheLantern1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [110.70,-14.45,139.65,-9.80,147.75,14.50,159.90,22.05,170.90,53.35,207.40,67.25,226.50,122.75,232.30,198.65,232.90,268.75,220.15,296.55,190.60,308.70,197.00,323.80,194.65,348.10,173.25,362.00,117.05,370.70,63.70,364.35,23.15,347.55,23.15,321.50,28.95,307.00,0.60,298.30,-11.80,283.10,-12.75,248.50,-8.65,178.45,-1.70,106.05,10.45,71.25,51.00,54.45,62.60,23.20,75.90,15.10,77.75,3.75,80.00,-8.05];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheLantern.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 219.00;
	sprite.height = 355.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol17(this: IMaryShelleyCutouts_Symbol17) {
	return this;
}
function MaryShelleyCutouts_sheLantern(this: IMaryShelleyCutouts_sheLantern) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-lantern.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheMoustache1(this: IMaryShelleyCutouts_sheMoustache1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [187.20,-13.95,222.10,-6.95,245.90,4.65,292.45,1.80,293.60,27.35,257.00,65.75,218.05,77.95,187.25,76.20,157.60,64.00,118.65,76.75,79.10,82.00,36.10,69.20,8.75,49.45,-9.25,29.70,-7.50,0.60,37.85,5.85,70.85,-4.75,99.40,-16.05,148.25,1.15];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheMoustache.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 281.00;
	sprite.height = 68.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol18(this: IMaryShelleyCutouts_Symbol18) {
	return this;
}
function MaryShelleyCutouts_sheMoustache(this: IMaryShelleyCutouts_sheMoustache) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-moustache.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_shePie1(this: IMaryShelleyCutouts_shePie1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [486.75,20.40,519.90,35.55,576.35,53.00,617.70,62.90,630.50,78.60,629.95,110.05,615.40,121.70,604.35,178.70,593.25,224.10,533.30,247.40,447.70,263.15,347.05,273.05,264.95,272.50,176.45,263.75,106.55,251.50,34.95,228.25,23.30,211.95,3.50,122.25,-11.00,108.00,-11.70,75.85,3.60,61.35,41.35,54.80,68.15,42.55,97.25,36.75,129.85,20.45,225.35,1.20,263.15,-9.30,307.40,-12.75,362.70,-7.55,394.75,1.20];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_shePie.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 619.00;
	sprite.height = 260.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol19(this: IMaryShelleyCutouts_Symbol19) {
	return this;
}
function MaryShelleyCutouts_shePie(this: IMaryShelleyCutouts_shePie) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-pie.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheSandwich1(this: IMaryShelleyCutouts_sheSandwich1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [170.75,6.60,203.55,20.20,212.95,34.70,215.80,65.20,217.20,93.80,207.80,111.65,196.10,120.55,186.20,151.50,175.40,163.20,157.60,205.90,138.35,215.25,109.30,208.70,70.80,196.50,20.65,188.50,-0.45,179.60,-9.85,166.95,-12.20,121.05,-7.50,99.45,25.80,38.45,31.00,13.15,37.95,-3.25,66.15,-13.10,97.10,-9.85,132.75,6.10];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheSandwich.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 204.00;
	sprite.height = 203.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol20(this: IMaryShelleyCutouts_Symbol20) {
	return this;
}
function MaryShelleyCutouts_sheSandwich(this: IMaryShelleyCutouts_sheSandwich) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-sandwich.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheSillyglasses1(this: IMaryShelleyCutouts_sheSillyglasses1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [31.60,38.90,54.30,14.70,112.25,-8.75,165.10,-1.45,191.50,13.95,233.30,-8.05,295.65,-5.10,323.55,19.10,325.75,63.85,316.95,71.20,309.60,109.35,286.85,137.95,249.45,145.30,227.45,139.40,203.95,154.10,184.90,154.80,167.30,145.30,135.75,159.95,95.40,156.30,68.25,136.50,55.80,118.85,49.90,95.40,4.45,87.35,-8.75,72.65,-7.40,58.25,-6.55,43.30];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheSillyglasses.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 317.00;
	sprite.height = 146.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol21(this: IMaryShelleyCutouts_Symbol21) {
	return this;
}
function MaryShelleyCutouts_sheSillyglasses(this: IMaryShelleyCutouts_sheSillyglasses) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-sillyglasses.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheSuperhero1(this: IMaryShelleyCutouts_sheSuperhero1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [248.25,-2.95,275.45,24.25,285.70,46.25,330.50,74.20,370.15,116.05,395.15,174.05,406.15,233.50,402.50,283.45,382.65,351.00,359.15,365.70,337.10,376.70,280.55,414.15,321.65,445.75,322.40,485.40,366.45,524.35,389.95,555.90,398.80,582.35,395.85,606.60,362.05,609.50,329.75,607.30,272.45,619.80,273.95,628.60,312.10,643.30,320.20,664.60,315.10,690.30,290.10,707.20,244.60,709.40,185.10,696.90,120.45,710.15,80.05,707.20,54.35,691.75,47.75,676.35,47.75,650.65,66.10,635.95,94.00,630.80,105.05,579.40,86.70,574.25,73.50,532.40,58.80,523.60,53.65,497.90,41.15,472.90,43.40,439.85,86.70,416.35,47.80,378.90,30.90,370.80,19.85,348.05,-1.45,331.15,-13.20,299.60,-9.50,271.70,-2.15,259.95,-5.10,204.20,8.85,141.05,36.00,95.50,77.85,59.55,117.55,43.35,146.15,5.15,178.50,-10.25,207.85,-13.20];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheSuperhero.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 391.00;
	sprite.height = 697.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol22(this: IMaryShelleyCutouts_Symbol22) {
	return this;
}
function MaryShelleyCutouts_sheSuperhero(this: IMaryShelleyCutouts_sheSuperhero) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-superhero.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheSuperheroArmout1(this: IMaryShelleyCutouts_sheSuperheroArmout1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [295.50,-2.95,322.70,24.25,332.95,46.25,377.75,74.20,417.40,116.05,442.40,174.05,453.40,233.50,449.75,283.45,429.90,351.00,406.40,365.70,384.35,376.70,327.80,414.15,368.90,445.75,369.65,485.40,413.70,524.35,437.20,555.90,446.05,582.35,443.10,606.60,409.30,609.50,377.00,607.30,319.70,619.80,321.20,628.60,359.35,643.30,367.45,664.60,362.35,690.30,337.35,707.20,291.85,709.40,232.35,696.90,167.70,710.15,127.30,707.20,101.60,691.75,95.00,676.35,95.00,650.65,113.35,635.95,141.25,630.80,150.10,594.90,149.60,548.75,157.85,494.75,120.15,491.25,98.25,492.60,91.40,492.35,64.90,485.85,35.40,489.40,9.90,485.55,-10.70,460.55,-11.30,428.65,5.35,409.70,32.45,405.10,65.50,406.85,88.45,395.05,99.70,390.95,104.80,388.30,95.05,378.90,78.15,370.80,67.10,348.05,45.80,331.15,34.05,299.60,37.75,271.70,45.10,259.95,42.15,204.20,56.10,141.05,83.25,95.50,125.10,59.55,164.80,43.35,193.40,5.15,225.75,-10.25,255.10,-13.20];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheSuperheroArmout.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 437.00;
	sprite.height = 697.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol23(this: IMaryShelleyCutouts_Symbol23) {
	return this;
}
function MaryShelleyCutouts_sheSuperheroArmout(this: IMaryShelleyCutouts_sheSuperheroArmout) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-superhero-armout.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheTeddybear1(this: IMaryShelleyCutouts_sheTeddybear1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [203.85,19.40,210.30,33.10,208.40,57.05,197.00,75.70,184.40,112.95,183.65,117.50,202.65,141.45,202.65,169.60,198.85,178.70,241.80,189.75,250.55,203.40,250.90,229.25,234.95,250.55,219.05,265.40,197.40,268.05,184.05,265.40,172.65,285.95,155.55,301.15,127.40,303.40,107.25,294.30,84.45,282.50,64.70,265.80,49.10,242.20,33.90,212.15,15.25,210.25,-7.60,190.45,-11.00,175.25,-9.10,160.45,1.50,148.25,11.45,127.40,33.85,107.25,31.95,86.30,33.10,66.95,24.75,53.25,21.30,34.60,26.65,10.30,50.20,-8.00,73.05,-8.75,92.80,0.00,124.00,2.65,151.70,3.45,189.35,0.75];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheTeddybear.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 240.00;
	sprite.height = 292.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol24(this: IMaryShelleyCutouts_Symbol24) {
	return this;
}
function MaryShelleyCutouts_sheTeddybear(this: IMaryShelleyCutouts_sheTeddybear) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-teddybear.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheTophat1(this: IMaryShelleyCutouts_sheTophat1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [32.15,32.80,107.20,7.15,242.75,-12.60,303.85,-11.30,343.75,-4.15,361.60,14.30,364.60,44.10,365.20,113.80,368.75,185.30,372.90,228.15,399.75,221.60,424.15,232.95,427.75,265.10,411.05,284.75,448.60,294.85,459.30,305.60,459.90,328.85,434.30,351.45,408.10,362.80,384.85,359.80,359.80,292.50,336.65,318.10,296.75,332.40,228.80,336.60,198.45,353.30,172.20,369.35,162.10,386.05,127.55,403.90,106.70,401.55,94.75,396.75,83.45,424.15,48.90,426.55,9.60,420.00,-8.30,407.50,-7.70,378.90,20.30,358.05,57.25,340.80,22.70,330.65,13.15,313.95,13.75,280.00,46.50,261.55,25.05,188.25,5.35,133.45,-12.50,98.30,-11.25,80.75,-9.55,63.15];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheTophat.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 450.00;
	sprite.height = 414.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol25(this: IMaryShelleyCutouts_Symbol25) {
	return this;
}
function MaryShelleyCutouts_sheTophat(this: IMaryShelleyCutouts_sheTophat) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-tophat.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheToy1(this: IMaryShelleyCutouts_sheToy1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [120.80,-3.45,145.35,6.90,154.55,14.60,164.50,-2.30,194.40,-3.05,214.35,5.00,216.65,28.00,212.45,50.60,227.00,61.00,233.15,80.55,232.35,109.30,240.80,116.95,255.35,146.45,253.80,176.30,238.50,184.75,217.75,185.50,196.30,180.15,176.00,188.20,151.05,185.90,135.75,165.95,122.30,162.90,99.70,173.25,68.65,169.80,52.55,150.65,32.60,158.70,6.55,153.70,-8.80,137.20,-11.10,109.25,-2.65,86.20,15.35,75.10,22.65,16.55,40.30,-6.10,69.40,-11.85];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheToy.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 244.00;
	sprite.height = 177.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol26(this: IMaryShelleyCutouts_Symbol26) {
	return this;
}
function MaryShelleyCutouts_sheToy(this: IMaryShelleyCutouts_sheToy) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-toy.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheWand1(this: IMaryShelleyCutouts_sheWand1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [217.55,-7.80,243.30,13.20,291.85,-7.80,320.60,-8.40,321.20,18.00,306.80,59.35,337.20,83.30,342.50,106.25,277.45,126.45,265.50,175.00,237.95,174.40,218.15,143.25,147.45,218.10,91.75,272.60,27.00,331.95,4.25,333.15,-9.55,322.95,-9.55,292.40,67.75,213.90,145.05,141.40,176.85,110.20,142.65,98.85,138.45,85.10,141.45,69.50,189.35,50.35,184.20,13.40,190.50,-14.40];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheWand.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 325.00;
	sprite.height = 322.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol27(this: IMaryShelleyCutouts_Symbol27) {
	return this;
}
function MaryShelleyCutouts_sheWand(this: IMaryShelleyCutouts_sheWand) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-wand.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXBrave1(this: IMaryShelleyCutouts_sheXBrave1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [304.20,-10.50,310.05,9.45,340.60,36.45,361.75,81.10,361.75,116.30,381.70,145.70,388.75,186.80,389.95,213.80,402.85,227.90,401.70,285.45,367.60,352.40,339.45,353.55,307.70,374.70,340.60,409.90,351.20,436.90,341.80,478.00,310.10,497.95,293.65,510.90,287.75,552.00,307.75,583.70,335.90,598.95,346.50,629.50,331.20,657.70,270.15,669.45,213.75,660.05,153.90,675.30,90.50,670.60,59.95,654.15,56.40,623.65,65.80,598.95,99.85,589.60,102.20,566.10,132.75,557.85,129.25,507.35,97.50,482.70,79.95,448.60,82.25,405.25,110.40,378.15,77.55,358.20,51.70,362.90,27.05,354.65,1.20,312.40,-7.00,258.40,0.05,226.65,15.30,218.45,14.10,178.55,25.85,138.60,50.50,99.85,31.70,98.65,20.00,75.15,-3.50,68.15,-13.95,45.80,-9.10,16.45,16.90,2.95,49.60,3.90,65.00,18.35,66.00,46.25,84.25,72.25,146.35,52.45,180.50,40.90,250.80,45.75,246.95,20.70,249.60,1.95,264.25,-12.85];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXBrave.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 389.00;
	sprite.height = 660.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol28(this: IMaryShelleyCutouts_Symbol28) {
	return this;
}
function MaryShelleyCutouts_sheXBrave(this: IMaryShelleyCutouts_sheXBrave) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-brave.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXDefend1(this: IMaryShelleyCutouts_sheXDefend1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [286.20,-9.85,296.50,4.10,296.80,28.80,310.45,21.20,334.45,23.55,354.35,43.15,375.55,90.10,377.05,134.80,374.05,159.05,382.35,192.35,379.30,225.30,387.60,249.50,383.50,285.85,377.00,313.50,425.55,315.70,439.95,330.10,444.15,355.80,429.65,387.45,405.85,399.00,380.85,402.00,324.10,427.75,274.85,446.70,294.55,539.05,287.75,564.80,292.25,584.45,300.60,591.30,303.65,604.15,333.90,617.00,343.75,643.50,336.95,668.50,309.70,682.90,270.35,688.95,247.60,687.45,211.30,694.25,155.25,688.95,116.65,679.10,108.30,663.20,106.80,641.25,121.20,605.70,131.80,601.15,137.05,567.05,128.00,551.90,128.75,530.70,103.00,511.75,85.60,483.00,78.05,460.30,82.55,425.45,94.70,406.55,112.10,395.95,67.45,367.90,38.65,363.35,14.45,353.55,-2.25,320.20,-13.60,277.80,-8.30,239.95,9.15,219.50,10.65,176.45,22.75,143.15,43.95,109.80,32.60,80.30,14.45,77.25,1.55,59.10,2.30,31.10,19.95,12.20,51.55,7.60,78.05,23.50,81.80,54.55,96.20,71.95,144.65,59.10,180.25,57.60,203.70,53.80,242.65,54.20,231.30,38.30,233.40,5.80,252.15,-9.10];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXDefend.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 433.00;
	sprite.height = 681.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol29(this: IMaryShelleyCutouts_Symbol29) {
	return this;
}
function MaryShelleyCutouts_sheXDefend(this: IMaryShelleyCutouts_sheXDefend) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-defend.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXFunny1(this: IMaryShelleyCutouts_sheXFunny1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [267.80,-11.10,281.85,3.60,285.45,25.10,299.75,21.55,315.30,22.70,341.10,43.00,360.20,86.95,361.15,127.10,357.35,149.05,365.95,180.60,365.00,215.95,371.65,241.70,363.10,291.35,345.90,331.50,322.95,343.90,289.50,376.40,313.40,406.95,321.05,430.85,315.30,470.00,275.15,539.75,278.05,559.80,289.50,567.45,290.00,577.40,315.85,588.75,328.15,599.65,328.95,627.15,318.25,646.30,296.05,654.70,265.45,659.30,233.30,657.80,201.20,664.65,159.15,663.15,121.65,654.70,104.05,641.70,101.00,615.70,112.45,579.75,127.75,572.85,131.60,540.75,127.00,531.55,123.15,507.85,98.70,487.20,79.60,460.45,73.45,423.70,83.40,396.20,104.05,377.85,79.60,362.55,64.30,351.05,34.45,349.55,10.75,335.75,-7.60,294.45,-13.75,251.65,-4.55,217.25,6.90,211.10,9.20,169.85,22.20,131.60,40.55,102.50,32.90,78.80,14.55,71.90,0.80,62.00,2.30,28.30,24.50,9.20,58.90,9.95,76.50,23.75,77.25,52.80,91.05,68.85,139.25,54.35,171.75,54.75,192.15,49.70,229.50,48.20,219.55,36.75,220.25,6.75,239.20,-11.30];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXFunny.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 357.00;
	sprite.height = 651.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol30(this: IMaryShelleyCutouts_Symbol30) {
	return this;
}
function MaryShelleyCutouts_sheXFunny(this: IMaryShelleyCutouts_sheXFunny) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-funny.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXFunny_21(this: IMaryShelleyCutouts_sheXFunny_21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [268.75,18.45,280.25,21.50,291.80,-9.95,318.65,-9.95,338.60,3.85,361.65,37.65,371.60,86.05,368.55,117.50,357.05,141.30,370.85,177.40,376.25,216.55,373.15,242.65,380.05,268.70,372.35,313.25,341.65,366.20,323.25,370.80,304.05,397.70,285.60,411.50,301.00,471.40,317.10,512.85,322.50,558.90,315.60,585.00,306.35,591.15,312.50,611.10,334.80,618.80,349.35,632.60,348.60,662.55,330.15,678.70,295.65,688.70,250.35,689.45,215.80,698.65,165.85,694.80,122.85,681.75,110.60,670.25,109.80,644.90,124.40,608.85,108.30,601.90,92.90,578.90,92.90,550.50,101.35,535.90,108.30,492.90,119.00,444.50,128.25,410.75,92.15,391.55,69.15,376.95,53.00,356.25,30.75,353.95,9.25,337.05,-7.65,301.70,-13.00,261.80,-4.60,224.95,8.50,212.65,16.15,166.65,36.10,134.40,59.90,104.45,39.20,100.60,33.05,96.55,26.10,71.05,6.80,66.40,-4.25,45.50,-3.00,22.15,13.55,1.25,41.85,-1.20,66.40,13.55,73.15,32.60,70.10,46.10,83.60,63.30,94.05,84.80,118.00,78.05,153.05,42.40,195.45,28.30,224.95,24.60,250.35,14.60];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXFunny_2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 364.00;
	sprite.height = 683.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol31(this: IMaryShelleyCutouts_Symbol31) {
	return this;
}
function MaryShelleyCutouts_sheXFunny_2(this: IMaryShelleyCutouts_sheXFunny_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-funny_2.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXHide1(this: IMaryShelleyCutouts_sheXHide1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [360.45,16.50,374.95,25.25,383.70,-7.70,412.75,-10.60,441.80,14.60,460.25,46.55,465.75,90.15,455.65,130.20,468.95,171.55,472.80,220.00,488.30,253.90,494.15,276.20,528.05,292.65,572.65,326.50,579.40,361.40,591.05,366.25,592.00,387.55,603.65,398.20,602.65,425.35,585.25,436.95,581.35,451.50,560.05,454.40,560.05,469.90,536.80,476.70,504.80,468.95,457.35,467.95,374.05,475.70,320.75,469.85,258.75,472.75,198.65,469.85,155.05,466.95,83.35,467.95,53.30,477.65,33.90,470.85,32.95,456.30,14.55,453.40,8.70,435.00,-5.80,427.25,-11.60,401.10,1.95,383.65,3.90,364.25,13.55,358.45,18.40,328.60,66.85,287.75,100.75,278.05,106.60,247.05,123.05,240.25,139.55,216.05,140.50,178.30,150.20,146.35,163.75,124.05,152.10,121.15,141.45,100.80,119.20,93.05,109.50,65.90,115.30,42.65,137.60,29.10,167.60,34.90,180.20,50.40,181.20,71.70,201.55,88.20,243.20,74.65,268.40,46.55,298.40,34.90,323.60,30.05,333.30,19.45];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXHide.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 592.00;
	sprite.height = 463.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol32(this: IMaryShelleyCutouts_Symbol32) {
	return this;
}
function MaryShelleyCutouts_sheXHide(this: IMaryShelleyCutouts_sheXHide) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-hide.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXInvisible1(this: IMaryShelleyCutouts_sheXInvisible1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [276.85,-7.50,286.35,12.75,290.25,32.25,303.95,25.45,322.50,24.45,352.80,54.75,369.40,100.70,362.55,150.50,372.35,197.45,371.35,219.90,377.25,248.25,366.50,303.90,343.05,343.95,328.40,347.85,286.35,391.85,307.85,426.05,322.50,456.35,317.65,494.45,296.15,515.00,284.30,521.75,281.10,537.75,280.30,565.00,295.40,589.50,319.20,603.85,334.20,620.15,333.60,636.40,317.95,656.45,296.05,667.10,239.10,670.20,201.55,677.10,150.85,671.45,117.65,660.20,106.40,641.45,110.15,625.15,121.40,595.75,132.70,583.25,138.30,545.05,127.70,538.15,123.30,501.25,112.05,461.20,119.55,420.50,128.95,394.20,98.30,374.85,71.40,356.70,40.75,355.45,20.05,344.80,-1.85,309.10,-9.35,274.05,-6.20,240.90,13.20,214.60,13.15,180.20,21.95,144.55,50.10,102.00,41.35,96.95,36.30,78.20,17.55,73.80,5.65,61.30,5.65,33.15,25.70,13.75,45.10,10.60,70.10,20.60,77.00,40.65,76.35,56.90,90.15,75.05,140.20,58.80,179.00,55.65,209.05,51.30,251.00,53.15,233.45,38.75,228.45,16.25,237.20,-0.60,250.35,-10.50];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXInvisible.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 365.00;
	sprite.height = 665.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol33(this: IMaryShelleyCutouts_Symbol33) {
	return this;
}
function MaryShelleyCutouts_sheXInvisible(this: IMaryShelleyCutouts_sheXInvisible) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-invisible.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXKind1(this: IMaryShelleyCutouts_sheXKind1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [250.10,-9.85,288.55,-11.85,303.10,4.95,304.30,25.90,330.20,32.05,361.00,62.85,379.45,103.50,381.95,152.80,394.25,179.90,396.70,216.85,412.20,227.80,422.05,263.25,423.05,312.60,435.85,316.50,468.40,311.60,480.45,320.25,485.15,336.25,498.75,348.75,498.50,368.85,491.40,387.10,491.00,403.70,475.30,416.10,443.00,413.15,400.75,440.75,336.65,461.45,357.00,565.00,354.20,593.85,368.95,651.85,396.45,666.60,407.30,681.35,405.40,715.55,385.60,729.65,339.25,737.70,300.80,731.65,278.15,718.80,250.50,733.60,201.20,738.55,165.70,734.60,144.00,715.85,142.05,682.35,175.55,661.60,182.45,634.00,158.65,636.30,144.00,630.05,121.50,621.75,118.40,594.55,107.55,588.65,105.55,553.15,140.05,536.40,176.55,450.60,129.20,433.85,97.45,435.90,57.20,411.15,30.60,363.85,23.70,321.45,34.55,301.70,23.70,252.45,32.60,207.10,57.25,148.40,36.60,145.45,24.70,125.25,-0.95,119.35,-10.80,104.55,-10.40,74.45,6.95,53.30,40.50,50.30,66.10,65.10,69.05,96.65,80.90,101.60,88.80,117.40,144.00,97.65,170.65,92.75,202.20,82.85,268.25,69.05,265.65,53.30,249.55,52.30,235.70,42.80,234.30,30.70,234.10,13.60];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXKind.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 488.00;
	sprite.height = 724.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol34(this: IMaryShelleyCutouts_Symbol34) {
	return this;
}
function MaryShelleyCutouts_sheXKind(this: IMaryShelleyCutouts_sheXKind) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-kind.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXRun1(this: IMaryShelleyCutouts_sheXRun1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [157.80,-11.45,170.60,7.70,169.30,39.00,203.20,44.75,244.10,50.55,283.75,65.85,302.25,52.45,314.40,51.15,318.90,29.45,341.90,12.20,375.75,15.40,390.45,33.25,391.75,63.95,371.95,86.95,343.80,88.85,327.20,107.40,345.10,146.35,349.55,180.20,348.90,197.45,367.45,221.75,369.35,266.50,350.85,311.85,340.60,325.30,357.25,339.35,364.25,355.30,396.20,369.40,399.40,392.40,428.80,399.40,457.60,416.05,474.20,448.00,473.55,485.70,462.05,517.00,447.35,527.85,420.50,529.80,401.35,520.85,390.45,501.65,367.45,537.45,341.25,573.90,336.80,599.45,321.45,611.60,307.40,633.30,285.00,639.70,256.25,633.30,223.00,609.70,200.65,573.90,190.40,534.90,195.55,501.05,219.80,480.55,262.00,479.30,210.95,426.25,186.00,456.30,154.05,458.85,112.50,449.25,82.50,443.50,65.85,422.40,65.20,387.25,74.15,362.35,49.90,348.95,30.10,331.70,17.95,326.55,-1.25,294.65,-14.05,251.15,-13.40,224.95,-5.75,199.35,-9.55,175.05,-2.55,132.90,1.30,81.80,16.65,38.35,46.05,10.25,74.80,8.95,82.50,26.85,90.80,18.55,108.05,21.10,108.70,4.45,120.75,-11.45];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXRun.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 460.00;
	sprite.height = 627.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol35(this: IMaryShelleyCutouts_Symbol35) {
	return this;
}
function MaryShelleyCutouts_sheXRun(this: IMaryShelleyCutouts_sheXRun) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-run.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXShare1(this: IMaryShelleyCutouts_sheXShare1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [285.05,-12.40,295.35,1.55,295.65,26.25,309.30,18.65,333.30,21.00,353.20,40.60,374.40,87.55,375.90,132.25,372.90,156.50,381.20,189.80,378.15,222.75,386.45,246.95,382.35,283.30,375.85,310.95,424.40,313.15,438.80,327.55,443.00,353.25,428.50,384.90,404.70,396.45,379.70,399.45,322.95,425.20,273.70,444.15,293.40,536.50,286.60,562.25,291.10,581.90,299.45,588.75,302.50,601.60,332.75,614.45,342.60,640.95,335.80,665.95,308.55,680.35,269.20,686.40,246.45,684.90,210.15,691.70,154.10,686.40,115.50,676.55,107.15,660.65,105.65,638.70,120.05,603.15,130.65,598.60,135.90,564.50,126.85,549.35,127.60,528.15,101.85,509.20,84.45,480.45,76.90,457.75,81.40,422.90,93.55,404.00,110.95,393.40,66.30,365.35,37.50,360.80,13.30,351.00,-3.40,317.65,-14.75,275.25,-9.45,237.40,8.00,216.95,9.50,173.90,21.60,140.60,42.80,107.25,31.45,77.75,13.30,74.70,0.40,56.55,1.15,28.55,18.80,9.65,50.40,5.05,76.90,20.95,80.65,52.00,95.05,69.40,143.50,56.55,179.10,55.05,202.55,51.25,241.50,51.65,230.15,35.75,232.25,3.25,251.00,-11.65];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXShare.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 431.00;
	sprite.height = 678.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_sheXShare(this: IMaryShelleyCutouts_sheXShare) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-share.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXSpooky1(this: IMaryShelleyCutouts_sheXSpooky1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [268.95,-10.95,283.80,7.75,308.30,5.20,334.75,24.55,355.40,71.60,357.95,114.20,352.80,136.75,363.10,170.95,363.75,212.20,369.55,236.70,363.75,283.10,348.25,321.80,335.35,336.00,319.25,341.80,278.60,379.85,292.15,390.15,320.55,386.30,342.45,385.00,365.70,399.85,368.30,458.50,352.80,463.65,340.55,463.00,316.70,473.95,285.10,473.95,247.05,458.50,247.05,507.50,239.30,526.20,269.00,537.15,274.80,553.95,299.30,564.25,313.50,581.00,311.55,610.05,291.55,628.75,256.05,635.20,211.55,633.30,183.85,646.80,132.25,650.05,89.05,640.35,61.95,627.45,60.00,599.10,79.35,563.00,91.60,558.45,94.85,527.50,90.35,509.45,93.55,484.30,71.65,479.15,53.55,457.20,35.50,455.90,28.40,439.15,30.35,416.60,39.40,394.65,80.65,379.15,89.70,365.00,65.85,348.20,35.50,345.65,17.45,337.25,1.35,314.00,-11.55,281.15,-12.85,251.45,-4.45,216.00,7.80,208.90,7.75,176.10,16.15,143.85,29.05,120.00,39.35,104.50,32.90,77.45,12.95,71.65,-0.60,55.50,1.30,24.55,23.90,8.45,56.80,7.80,75.50,21.95,78.05,52.30,87.75,65.80,121.90,56.80,152.20,52.95,178.00,42.60,221.20,36.80,218.65,16.80,223.15,0.70,230.80,-5.25,238.00,-12.20];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXSpooky.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 358.00;
	sprite.height = 635.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol36(this: IMaryShelleyCutouts_Symbol36) {
	return this;
}
function MaryShelleyCutouts_sheXSpooky(this: IMaryShelleyCutouts_sheXSpooky) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-spooky.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXStatue1(this: IMaryShelleyCutouts_sheXStatue1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [292.85,-10.45,304.95,-1.60,308.15,21.00,335.60,16.95,354.15,29.05,374.30,58.10,384.80,103.25,375.10,154.10,379.70,188.50,376.75,221.85,383.20,247.65,399.30,252.50,419.50,271.85,417.90,301.65,394.50,312.15,392.10,346.85,370.30,395.25,321.90,415.40,282.35,424.30,299.30,508.20,298.50,534.80,294.50,544.50,300.15,563.85,306.50,569.00,309.40,582.55,336.60,594.00,347.95,616.70,346.05,647.15,346.10,713.10,334.00,729.20,312.25,734.05,192.85,731.65,91.20,734.85,71.05,730.85,62.95,715.50,63.75,618.70,71.85,597.75,106.50,584.85,110.90,563.80,140.40,552.55,139.55,521.90,144.40,469.50,131.50,484.00,113.75,521.10,92.00,534.00,62.15,532.40,45.20,523.55,41.15,505.80,49.20,478.35,58.90,470.30,54.05,443.65,57.30,408.95,72.60,388.00,89.55,374.30,61.35,351.70,39.55,347.70,22.60,323.50,8.10,288.80,4.90,256.50,8.90,225.85,6.45,184.75,16.95,142.00,41.95,103.30,27.45,101.65,21.00,77.45,3.25,73.45,-12.10,58.90,-9.65,31.50,3.25,10.50,33.90,6.50,55.65,13.75,66.15,29.90,66.95,52.45,82.30,72.65,128.30,58.10,174.25,54.10,213.80,46.00,254.10,47.65,242.85,30.70,246.85,7.30,262.20,-11.30];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXStatue.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 408.00;
	sprite.height = 721.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol37(this: IMaryShelleyCutouts_Symbol37) {
	return this;
}
function MaryShelleyCutouts_sheXStatue(this: IMaryShelleyCutouts_sheXStatue) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-statue.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheXSurprised1(this: IMaryShelleyCutouts_sheXSurprised1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [61.05,0.85,82.20,14.70,85.45,46.40,97.65,57.80,140.75,52.10,189.60,48.85,177.40,35.85,180.65,9.00,194.50,-10.55,228.65,-13.00,243.30,0.05,241.65,26.90,258.75,29.35,262.85,46.40,282.35,41.55,292.10,28.50,293.45,14.85,317.90,12.25,340.95,29.35,362.90,67.55,370.25,101.70,365.35,140.80,347.45,170.10,349.10,215.60,337.70,274.20,326.30,309.15,316.55,342.55,295.40,361.25,317.35,374.25,327.95,399.50,324.65,423.10,309.20,448.35,271.30,460.95,266.85,553.80,278.30,563.40,281.55,577.70,301.05,583.40,317.35,598.85,320.60,624.90,309.20,647.70,276.65,656.65,225.40,659.90,187.15,665.55,144.05,662.30,105.80,651.75,91.15,637.90,90.30,615.95,102.55,593.15,101.70,579.30,116.35,571.20,119.60,528.05,120.45,497.15,102.55,500.40,89.50,523.20,69.15,527.25,44.75,519.10,27.65,517.50,10.60,491.45,13.00,449.95,15.45,417.40,31.75,384.05,60.20,362.90,46.40,353.10,19.55,344.15,1.65,316.50,-10.55,287.20,-13.00,257.90,-7.30,227.00,-9.75,185.55,-1.60,141.60,22.00,105.80,39.90,87.10,38.25,71.65,17.10,66.75,5.70,46.40,8.15,19.55,20.35,4.90,35.80,0.05];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheXSurprised.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 354.00;
	sprite.height = 651.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol38(this: IMaryShelleyCutouts_Symbol38) {
	return this;
}
function MaryShelleyCutouts_sheXSurprised(this: IMaryShelleyCutouts_sheXSurprised) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-x-surprised.png", 0.000, 0.000);
	return this;
}
function MaryShelleyCutouts_sheGhost1(this: IMaryShelleyCutouts_sheGhost1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [382.05,-8.60,442.40,11.50,465.35,94.80,468.25,175.25,467.30,220.25,519.90,269.10,589.80,345.70,618.55,391.60,640.60,469.20,636.75,501.75,606.10,518.95,605.15,544.80,563.95,565.90,516.10,561.10,482.60,549.60,497.90,620.50,527.60,709.55,576.40,718.15,619.50,722.00,627.15,751.65,604.20,772.75,567.80,785.20,521.85,787.10,499.80,810.10,462.45,814.85,435.65,808.15,413.70,839.75,366.80,854.15,325.60,855.10,308.40,847.45,266.25,851.25,227.95,837.85,176.20,840.70,125.45,825.40,90.00,799.55,79.50,783.25,79.50,751.65,54.60,719.10,48.85,695.15,66.10,652.05,107.25,572.60,63.20,573.55,21.10,549.60,17.25,531.40,-4.75,517.05,-13.40,450.00,-5.75,387.80,14.35,332.25,74.70,282.45,158.05,210.70,156.10,156.10,168.55,92.90,190.60,48.85,221.25,12.45,266.25,-7.65,318.85,-12.45];
	}
	const sprite = this.sprite;
	MaryShelleyCutouts_sheGhost.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 627.00;
	sprite.height = 841.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MaryShelleyCutouts_Symbol39(this: IMaryShelleyCutouts_Symbol39) {
	return this;
}
function MaryShelleyCutouts_sheGhost(this: IMaryShelleyCutouts_sheGhost) {
	if (this.setLayoutTexture) this.setLayoutTexture("she-ghost.png", 0.000, 0.000);
	return this;
}
interface IMaryShelleyCutoutsArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IMaryShelleyCutoutsContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IMaryShelleyCutoutsSprite extends IMaryShelleyCutoutsContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IMaryShelleyCutoutsText extends IMaryShelleyCutoutsContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IMaryShelleyCutoutsPolygon extends IMaryShelleyCutoutsArray<number> {
}
interface IMaryShelleyCutouts {
	readonly cutouts: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_sheAnt1|IMaryShelleyCutouts_sheBestfriends11|IMaryShelleyCutouts_sheBestfriends21|IMaryShelleyCutouts_sheBestfriends31|IMaryShelleyCutouts_sheBg1|IMaryShelleyCutouts_sheBoogie1|IMaryShelleyCutouts_sheBookmonster1|IMaryShelleyCutouts_sheBookmonsterArmdown1|IMaryShelleyCutouts_sheBookmonsterArmup1|IMaryShelleyCutouts_sheBowtie1|IMaryShelleyCutouts_sheBroccoli1|IMaryShelleyCutouts_sheCrayons1|IMaryShelleyCutouts_sheFeather1|IMaryShelleyCutouts_sheFlashlight1|IMaryShelleyCutouts_sheLantern1|IMaryShelleyCutouts_sheMoustache1|IMaryShelleyCutouts_shePie1|IMaryShelleyCutouts_sheSandwich1|IMaryShelleyCutouts_sheSillyglasses1|IMaryShelleyCutouts_sheSuperhero1|IMaryShelleyCutouts_sheSuperheroArmout1|IMaryShelleyCutouts_sheTeddybear1|IMaryShelleyCutouts_sheTophat1|IMaryShelleyCutouts_sheToy1|IMaryShelleyCutouts_sheWand1|IMaryShelleyCutouts_sheXBrave1|IMaryShelleyCutouts_sheXDefend1|IMaryShelleyCutouts_sheXFunny1|IMaryShelleyCutouts_sheXFunny_21|IMaryShelleyCutouts_sheXHide1|IMaryShelleyCutouts_sheXInvisible1|IMaryShelleyCutouts_sheXKind1|IMaryShelleyCutouts_sheXRun1|IMaryShelleyCutouts_sheXShare1|IMaryShelleyCutouts_sheXSpooky1|IMaryShelleyCutouts_sheXStatue1|IMaryShelleyCutouts_sheXSurprised1|IMaryShelleyCutouts_sheGhost1>;
}
interface IMaryShelleyCutouts_sheAnt1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol1>;
	readonly sprite: IMaryShelleyCutouts_sheAnt;
}
interface IMaryShelleyCutouts_Symbol1 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheAnt extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheBestfriends11 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol2>;
	readonly sprite: IMaryShelleyCutouts_sheBestfriends1;
}
interface IMaryShelleyCutouts_Symbol2 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheBestfriends1 extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheBestfriends21 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol3>;
	readonly sprite: IMaryShelleyCutouts_sheBestfriends2;
}
interface IMaryShelleyCutouts_Symbol3 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheBestfriends2 extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheBestfriends31 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol4>;
	readonly sprite: IMaryShelleyCutouts_sheBestfriends3;
}
interface IMaryShelleyCutouts_Symbol4 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheBestfriends3 extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheBg1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol5|IMaryShelleyCutouts_Symbol6|IMaryShelleyCutouts_Symbol7>;
	readonly sprite: IMaryShelleyCutouts_sheBg;
}
interface IMaryShelleyCutouts_Symbol5 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_Symbol6 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_Symbol7 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheBg extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheBoogie1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol8>;
	readonly sprite: IMaryShelleyCutouts_sheBoogie;
}
interface IMaryShelleyCutouts_Symbol8 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheBoogie extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheBookmonster1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol9>;
	readonly sprite: IMaryShelleyCutouts_sheBookmonster;
}
interface IMaryShelleyCutouts_Symbol9 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheBookmonster extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheBookmonsterArmdown1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol10>;
	readonly sprite: IMaryShelleyCutouts_sheBookmonsterArmdown;
}
interface IMaryShelleyCutouts_Symbol10 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheBookmonsterArmdown extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheBookmonsterArmup1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol11>;
	readonly sprite: IMaryShelleyCutouts_sheBookmonsterArmup;
}
interface IMaryShelleyCutouts_Symbol11 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheBookmonsterArmup extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheBowtie1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol12>;
	readonly sprite: IMaryShelleyCutouts_sheBowtie;
}
interface IMaryShelleyCutouts_Symbol12 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheBowtie extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheBroccoli1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol13>;
	readonly sprite: IMaryShelleyCutouts_sheBroccoli;
}
interface IMaryShelleyCutouts_Symbol13 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheBroccoli extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheCrayons1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol14>;
	readonly sprite: IMaryShelleyCutouts_sheCrayons;
}
interface IMaryShelleyCutouts_Symbol14 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheCrayons extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheFeather1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol15>;
	readonly sprite: IMaryShelleyCutouts_sheFeather;
}
interface IMaryShelleyCutouts_Symbol15 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheFeather extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheFlashlight1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol16>;
	readonly sprite: IMaryShelleyCutouts_sheFlashlight;
}
interface IMaryShelleyCutouts_Symbol16 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheFlashlight extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheLantern1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol17>;
	readonly sprite: IMaryShelleyCutouts_sheLantern;
}
interface IMaryShelleyCutouts_Symbol17 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheLantern extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheMoustache1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol18>;
	readonly sprite: IMaryShelleyCutouts_sheMoustache;
}
interface IMaryShelleyCutouts_Symbol18 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheMoustache extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_shePie1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol19>;
	readonly sprite: IMaryShelleyCutouts_shePie;
}
interface IMaryShelleyCutouts_Symbol19 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_shePie extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheSandwich1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol20>;
	readonly sprite: IMaryShelleyCutouts_sheSandwich;
}
interface IMaryShelleyCutouts_Symbol20 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheSandwich extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheSillyglasses1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol21>;
	readonly sprite: IMaryShelleyCutouts_sheSillyglasses;
}
interface IMaryShelleyCutouts_Symbol21 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheSillyglasses extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheSuperhero1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol22>;
	readonly sprite: IMaryShelleyCutouts_sheSuperhero;
}
interface IMaryShelleyCutouts_Symbol22 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheSuperhero extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheSuperheroArmout1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol23>;
	readonly sprite: IMaryShelleyCutouts_sheSuperheroArmout;
}
interface IMaryShelleyCutouts_Symbol23 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheSuperheroArmout extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheTeddybear1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol24>;
	readonly sprite: IMaryShelleyCutouts_sheTeddybear;
}
interface IMaryShelleyCutouts_Symbol24 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheTeddybear extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheTophat1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol25>;
	readonly sprite: IMaryShelleyCutouts_sheTophat;
}
interface IMaryShelleyCutouts_Symbol25 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheTophat extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheToy1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol26>;
	readonly sprite: IMaryShelleyCutouts_sheToy;
}
interface IMaryShelleyCutouts_Symbol26 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheToy extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheWand1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol27>;
	readonly sprite: IMaryShelleyCutouts_sheWand;
}
interface IMaryShelleyCutouts_Symbol27 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheWand extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXBrave1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol28>;
	readonly sprite: IMaryShelleyCutouts_sheXBrave;
}
interface IMaryShelleyCutouts_Symbol28 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheXBrave extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXDefend1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol29>;
	readonly sprite: IMaryShelleyCutouts_sheXDefend;
}
interface IMaryShelleyCutouts_Symbol29 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheXDefend extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXFunny1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol30>;
	readonly sprite: IMaryShelleyCutouts_sheXFunny;
}
interface IMaryShelleyCutouts_Symbol30 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheXFunny extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXFunny_21 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol31>;
	readonly sprite: IMaryShelleyCutouts_sheXFunny_2;
}
interface IMaryShelleyCutouts_Symbol31 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheXFunny_2 extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXHide1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol32>;
	readonly sprite: IMaryShelleyCutouts_sheXHide;
}
interface IMaryShelleyCutouts_Symbol32 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheXHide extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXInvisible1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol33>;
	readonly sprite: IMaryShelleyCutouts_sheXInvisible;
}
interface IMaryShelleyCutouts_Symbol33 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheXInvisible extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXKind1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol34>;
	readonly sprite: IMaryShelleyCutouts_sheXKind;
}
interface IMaryShelleyCutouts_Symbol34 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheXKind extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXRun1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol35>;
	readonly sprite: IMaryShelleyCutouts_sheXRun;
}
interface IMaryShelleyCutouts_Symbol35 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheXRun extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXShare1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol29>;
	readonly sprite: IMaryShelleyCutouts_sheXShare;
}
interface IMaryShelleyCutouts_sheXShare extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXSpooky1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol36>;
	readonly sprite: IMaryShelleyCutouts_sheXSpooky;
}
interface IMaryShelleyCutouts_Symbol36 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheXSpooky extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXStatue1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol37>;
	readonly sprite: IMaryShelleyCutouts_sheXStatue;
}
interface IMaryShelleyCutouts_Symbol37 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheXStatue extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheXSurprised1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol38>;
	readonly sprite: IMaryShelleyCutouts_sheXSurprised;
}
interface IMaryShelleyCutouts_Symbol38 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheXSurprised extends IMaryShelleyCutoutsSprite {
}
interface IMaryShelleyCutouts_sheGhost1 extends IMaryShelleyCutoutsContainer {
	readonly polygons: IMaryShelleyCutoutsArray<IMaryShelleyCutouts_Symbol39>;
	readonly sprite: IMaryShelleyCutouts_sheGhost;
}
interface IMaryShelleyCutouts_Symbol39 extends IMaryShelleyCutoutsPolygon {
}
interface IMaryShelleyCutouts_sheGhost extends IMaryShelleyCutoutsSprite {
}
